// Campus photo for /colleges/oregon-state-university: CC BY-SA 3.0, by Ian Poellet, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOSU_Lower_Campus_Quad_path_-_Corvallis_Oregon.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/oregon-state-university/; credited under the photo.
const photo = {
    "slug": "oregon-state-university",
    "alt": "A tree-lined path across the lower campus quad at Oregon State University in Corvallis, Oregon",
    "src": "/colleges/oregon-state-university/campus-1600.webp",
    "srcSmall": "/colleges/oregon-state-university/campus-800.webp",
    "srcMid": "/colleges/oregon-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/oregon-state-university/og.jpg",
    "title": "OSU Lower Campus Quad path - Corvallis Oregon",
    "author": "Ian Poellet",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOSU_Lower_Campus_Quad_path_-_Corvallis_Oregon.jpg",
    "read": "2026-10-01"
};

export default photo;
